import { useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Asset from '../AssetsGrid/Asset';
import styles from './RelatedProducts.module.css';

const ChevronLeft = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M10 12L6 8l4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ChevronRight = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M6 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const RelatedProducts = () => {
  const { relatedProducts, relatedStatus } = useSelector(state => state.singleProduct);
  const trackRef = useRef(null);
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(false);

  const updateArrows = () => {
    const t = trackRef.current;
    if (!t) return;
    setCanPrev(t.scrollLeft > 4);
    setCanNext(t.scrollLeft < t.scrollWidth - t.clientWidth - 4);
  };

  useEffect(() => {
    // Initialize arrow states after products render
    const timer = setTimeout(updateArrows, 50);
    return () => clearTimeout(timer);
  }, [relatedProducts, relatedStatus]);

  const scroll = (dir) => {
    const t = trackRef.current;
    if (!t) return;
    const slideWidth = t.firstElementChild?.offsetWidth ?? 200;
    t.scrollBy({ left: dir * (slideWidth + 14) * 2, behavior: 'smooth' });
  };

  if (relatedStatus === 'idle') return null;
  if (relatedStatus === 'succeeded' && relatedProducts.length === 0) return null;

  const showArrows = canPrev || canNext;

  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <div className={styles.header}>
          <h2 className={styles.title}>Related products</h2>
          {showArrows && (
            <div className={styles.arrows}>
              <button
                className={`${styles.arrow} ${!canPrev ? styles.arrowDisabled : ''}`}
                onClick={() => scroll(-1)}
                onMouseDown={e => e.preventDefault()}
                aria-label="Previous"
              >
                <ChevronLeft />
              </button>
              <button
                className={`${styles.arrow} ${!canNext ? styles.arrowDisabled : ''}`}
                onClick={() => scroll(1)}
                onMouseDown={e => e.preventDefault()}
                aria-label="Next"
              >
                <ChevronRight />
              </button>
            </div>
          )}
        </div>
        <div className={styles.track} ref={trackRef} onScroll={updateArrows}>
          {relatedStatus === 'loading'
            ? Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className={styles.slide}>
                  <div className={styles.skeleton} />
                </div>
              ))
            : relatedProducts.map((product, i) => (
                <div key={product.id} className={styles.slide}>
                  <Asset asset={product} animateIn={i < 6} />
                </div>
              ))
          }
        </div>
      </div>
    </section>
  );
};

export default RelatedProducts;
